/**
 * @param {Object} consentConfig
 * @param {Boolean} consentConfig.personalized_content
 * @param {Boolean} consentConfig.running_targeted_advertising
 * @param {Boolean} consentConfig.share_data_to_3rd_party
 *
 * @returns {String} expected to correspond to keys in the locale files
 */
export default function makeLocaleKey(consentConfig) {
  const {
    personalized_content: isPersonalized,
    running_targeted_advertising: isAdvertising,
    share_data_to_3rd_party: isSharing,
  } = consentConfig

  if ( isPersonalized ) {
    if ( isAdvertising ) {
      return ( isSharing ) ? 'personalizedContentAndAds' : 'personalizedContentAndAdsNoShare'
    }

    return ( isSharing ) ? 'personalizedContentAndShareData' : 'personalizedContent'
  }

  if ( isAdvertising ) {
    return ( isSharing ) ? 'personalizedAdsAndShareData' : 'personalizedAds'
  }

  return ( isSharing ) ? 'shareData' : 'defaultCopy'
}

